import React from 'react'
import { makeFooter } from './styled'
import FlexContainer from '../../shared/flex-container'
import { spacing_1 } from '../../theme/spacing'
import HeartIcon from 'components/corpSite/imgs/careguide-corp/icons/cg-heart-icon.svg'
import CareguideLogo from 'components/corpSite/imgs/careguide-corp/icons/cg.svg'
import LinkedInSocialIcon from 'components/corpSite/imgs/careguide-corp/icons/circle_li_hover_white.svg'
import FacebookSocialIcon from 'components/corpSite/imgs/careguide-corp/icons/circle_fb_hover_white.svg'
import TwitterSocialIcon from 'components/corpSite/imgs/careguide-corp/icons/circle_tw_hover_white.svg'

export const RawFooter = makeFooter('footer')

function Footer(props) {
  return (
    <RawFooter {...props}>
      <FlexContainer direction='row' justifyContent='space-between' flexWrap>
        <FlexContainer
          direction='row'
          justifyContent='space-around'
          flexWrap
          className='footer-links'
        >
          <div className='footer-section'>
            <strong>Services</strong>
            <a href='/child-care'>Child Care</a>
            <a href='/home-care'>Home Care</a>
            <a href='/pet-care'>Pet Care</a>
            <a href='/elder-care'>Elder Care</a>
            <a href='/payroll-services'>Payroll Services</a>
          </div>
          <div className='footer-section'>
            <strong>Discover</strong>
            <a href='https://help.careguide.com/hc/en-us/articles/360015774012'>
              Trust &amp; Safety
            </a>
            <a href='https://help.careguide.com/hc/en-us'>Help Center</a>
            <a href='/news-ideas'>News &amp; Ideas</a>
          </div>
          <div className='footer-section'>
            <strong>About CareGuide</strong>
            <a href='/about'>Company</a>
            <a href='/team'>Our Team</a>
            <a href='/careers'>Careers</a>
            <a href='/press'>Media Kit</a>
            <a href='/contact'>Contact</a>
          </div>
        </FlexContainer>
        <FlexContainer direction='row' marginBottom={spacing_1} className='special-links'>
          <div>
            <img src={CareguideLogo} />
            <div className='social-icons'>
              <a href='https://www.facebook.com/careguide'>
                <img src={FacebookSocialIcon} />
              </a>
              <a href='https://www.twitter.com/careguide'>
                <img src={TwitterSocialIcon} />
              </a>
              <a href='http://linkedin.com/company/careguide'>
                <img src={LinkedInSocialIcon} />
              </a>
            </div>
            <div className='policies'>
              <div>
                <a href='/privacy'>Privacy Policy</a>
              </div>
              <div>
                <a href='/terms-of-service'>Terms of Service</a>
              </div>
              <div>
                <a href='/privacy'>Cancellation Policy</a>
              </div>
            </div>
            <div className='copyright'>&copy; 2019 CareGuide Inc.</div>
          </div>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer
        direction='row'
        justifyContent='space-around'
        alignItems='center'
        marginTop={spacing_1}
        marginBottom={spacing_1}
      >
        <img src={HeartIcon} />
      </FlexContainer>
    </RawFooter>
  )
}

export default Footer
